module.exports = __webpack_public_path__ + "static/media/Logo_plus.10ed9600.svg";